module.exports = __webpack_public_path__ + "static/media/trimex_fina_marfil.cc7fd6e5.png";